import { Notification } from '@mantine/core'

export default {
    Notification: Notification.extend({
        defaultProps: {
            radius: 'md',
        }
    })
}